import { Theme, Box, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useIsMobileDevice } from "src/utils/hooks/useDeviceDetect";


interface ConversationPaneProps {
    isChatVisible: boolean;
    isLoading: boolean;
    onChatLoad: () => void;
    onCloseChat: () => void;
    onMoxoSubmitSuccess: () => void;
    onMoxoSubmitError: (error: string) => void;
}


const conversationWindowSize = (isMobile: boolean) => ({
    height: isMobile ? '60vh' : '500px',
    width: isMobile ? '80vw' : '400px',
});


const useChatWindowStyles = makeStyles((theme: Theme) => ({
    container: ({ isMobile }: { isMobile: boolean }) => ({
        right: isMobile ? '0px' : '20px',
        bottom: isMobile ? '0px' : '40px',
        display: 'flex',
        flexDirection: 'column',
        background: 'white',
        borderRadius: '16px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
        ...conversationWindowSize(isMobile),
    }),
    contentStyle: {
        backgroundColor: 'white',
        borderRadius: '20px',
        height: 'fit-content',
        width: 'fit-content',
    }
}));



interface LayoutProps {
    isChatVisible: boolean;
    children: React.ReactNode;

}

const Layout = ({ children, isChatVisible }: LayoutProps) => {
    const isMobile = useIsMobileDevice();
    const styles = useChatWindowStyles({ isMobile });

    if (!isChatVisible) return null;

    return (<Box className={styles.container}>{children}</Box>);
};

const ConversationPane = (conversationProps: ConversationPaneProps) => {

    const {
        onChatLoad,
        isChatVisible,
        onCloseChat,
    } = conversationProps;

    const isMobile = useIsMobileDevice();
    const styles = useChatWindowStyles({ isMobile });

    const { height, width } = conversationWindowSize(isMobile);

    useEffect(() => {
        onChatLoad();
    }, [])

    if (!isChatVisible) return null;

    return (
        <Layout isChatVisible={isChatVisible}>
            <Box
                className={styles.contentStyle}
                sx={{
                    iframe: {
                        border: '1px solid rgba(0, 0, 0, 0.05)', // No !important
                    },
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <Button
                        aria-label="close-chat"
                        onClick={onCloseChat}>
                        <CloseIcon />
                    </Button>
                </Box>

                <Box
                    aria-label="moxo-chat-pane"
                    id="moxo-chat"
                    sx={{
                        flex: 1,
                        height,
                        width,
                        overflow: 'hidden',
                        border: '1px solid rgba(0, 0, 0, 0.05)', // No !important
                        borderRadius: '12px',
                        bottom: '-60px',
                        right: '-17px',
                        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
                    }}
                >
                </Box>
            </Box>
        </Layout>
    );
}

export default ConversationPane;